 document.addEventListener('DOMContentLoaded',()=>{
    waitForViewer();
    updateDrawer('open')
    updateDrawer('closed')
    let allButtons = document.querySelectorAll('.viewButton')
    allButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        allButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
      });
    });

  })
  function updateDrawer(divID){
    let button = document.getElementById(divID)
    button.addEventListener('click',()=>{
      let viewer = document.querySelector('cylindo-viewer')
      viewer.configuration = 'DOOR POSITION:'+ divID.toUpperCase()
    })
  }
  function waitForViewer(retries = 5) {
    let viewer = document.querySelector('#cylindo-viewer');
    let openClosed = document.querySelector('#open-closed-cont');
    let isFlex = openClosed.style.display == 'flex'
    console.log("this is isflex ", isFlex)
    if(!isFlex){
      if (viewer) {
          viewer.addEventListener('loaded', () => {
              openClosed.style.display = 'flex';
              retries = 10
          });
          if(openClosed.style.display == ""){
              openClosed.style.display = 'flex';
          }else{
              if(retries > 0){
                  setTimeout(() => waitForViewer(retries - 1), 1000);
              }
          }
      } else if (retries > 0) {
          setTimeout(() => waitForViewer(retries - 1), 1000);
      } else {
          console.error('Viewer not found after multiple attempts');
      }
  }
}